"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SelectFieldCaret_1 = __importDefault(require("./SelectFieldCaret"));
var SelectFieldSingleValue = react_1.default.memo(function (_a) {
    var ariaLabel = _a.ariaLabel, childIsLabel = _a.childIsLabel, disabled = _a.disabled, display = _a.display, fixedValue = _a.fixedValue, imageIconPath = _a.imageIconPath, inputRef = _a.inputRef, name = _a.name, onChange = _a.onChange, onClose = _a.onClose, onCloseAction = _a.onCloseAction, onOpen = _a.onOpen, open = _a.open, onSelected = _a.onSelected, onUnselected = _a.onUnselected, placeholder = _a.placeholder, value = _a.value;
    var onKeyDown = function (event) {
        switch (event.key) {
            case "Enter":
                if (!open) {
                    onOpen();
                }
                break;
            case "Escape":
                if (open) {
                    onClose();
                }
                break;
            default:
                break;
        }
    };
    var onClick = function () {
        if (!childIsLabel && onCloseAction && open) {
            onClose();
            onCloseAction();
            return;
        }
        onOpen();
    };
    var classes = fixedValue ? "chq-ffd--ctrl chq-ffd--ctrl--fixed-value" : "chq-ffd--ctrl";
    return (react_1.default.createElement(react_1.default.Fragment, null,
        imageIconPath && (react_1.default.createElement("img", { className: "chq-ffd--sl--icon", src: imageIconPath, alt: "Input icon" })),
        react_1.default.createElement("input", { "aria-label": name, type: "hidden", disabled: disabled, id: name, name: name, value: value || "" }),
        react_1.default.createElement("input", { "aria-label": ariaLabel || "Value", type: "text", ref: inputRef, className: classes, disabled: disabled, onClick: onClick, onChange: onChange, onKeyDown: onKeyDown, onFocus: onSelected, onBlur: onUnselected, placeholder: placeholder, value: display, style: imageIconPath ? { paddingLeft: "40px" } : {} }),
        react_1.default.createElement(SelectFieldCaret_1.default, { open: open })));
});
exports.default = SelectFieldSingleValue;
